import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import { DatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import React, { Component } from "react";
import InputFiled from "../../FormElement/InputFiled";

class TicketDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ticketDetails: {
        // commodity: props.ticketDetails.commodity  && props.ticketDetails.commodity.name,
        // commodityVariety: props.ticketDetails && props.ticketDetails.commodityVariety,
        // estimatedHomeScaleShrinkBushels: props.ticketDetails && props.ticketDetails.estimatedHomeScaleShrinkBushels,
        // fieldEstimatedLoadBushels:  props.ticketDetails && props.ticketDetails.fieldEstimatedLoadBushels,
        // fieldEstimatedLoadWeight: props.ticketDetails && props.ticketDetails.fieldEstimatedLoadWeight,
        // fieldsEstimatedMoisture: props.ticketDetails && props.ticketDetails.fieldsEstimatedMoisture,
        // homeScaleEstimatedMoisture: props.ticketDetails && props.ticketDetails.homeScaleEstimatedMoisture,
        // homeScaleWeightEmpty: props.ticketDetails && props.ticketDetails.homeScaleWeightEmpty,
        // homeScaleWeightFilled: props.ticketDetails && props.ticketDetails.homeScaleWeightFilled,
        // shrinkMultiplier: props.ticketDetails && props.ticketDetails.shrinkMultiplier
      }
    };
  }

  handleChange = () => {
    //just to pass required handle change property to input
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.ticketDetails &&
      nextProps.ticketDetails !== this.props.ticketDetails
    )
      this.setState({
        ticketDetails: {
          commodity:
            nextProps.ticketDetails && nextProps.ticketDetails.commodity
              ? nextProps.ticketDetails.commodity.name
              : "",
          commodityVariety:
            nextProps.ticketDetails && nextProps.ticketDetails.commodityVariety
              ? nextProps.ticketDetails.commodityVariety.variety
              : "",
          estimatedHomeScaleShrinkBushels: nextProps.ticketDetails
            ? nextProps.ticketDetails.estimatedHomeScaleShrinkBushels
            : "",
          fieldEstimatedLoadBushels: nextProps.ticketDetails
            ? nextProps.ticketDetails.fieldEstimatedLoadBushels
            : "",
          fieldEstimatedLoadWeight: nextProps.ticketDetails
            ? nextProps.ticketDetails.fieldEstimatedLoadWeight
            : "",
          fieldsEstimatedMoisture: nextProps.ticketDetails
            ? nextProps.ticketDetails.fieldsEstimatedMoisture
            : "",
          homeScaleEstimatedMoisture: nextProps.ticketDetails
            ? nextProps.ticketDetails.homeScaleEstimatedMoisture
            : "",
          homeScaleWeightEmpty: nextProps.ticketDetails
            ? nextProps.ticketDetails.homeScaleWeightEmpty
            : "",
          homeScaleWeightFilled: nextProps.ticketDetails
            ? nextProps.ticketDetails.homeScaleWeightFilled
            : "",
          shrinkMultiplier: nextProps.ticketDetails
            ? nextProps.ticketDetails.shrinkMultiplier
            : "",
          billOfLading: nextProps.ticketDetails
            ? nextProps.ticketDetails.billOfLading
            : "",
          loadNumberIndValue: nextProps.ticketDetails
            ? nextProps.ticketDetails.loadNumberIndValue
            : "",
          ticketNumber: nextProps.ticketDetails
            ? nextProps.ticketDetails.ticketNumber
            : "",
          destination: nextProps.ticketDetails
            ? nextProps.ticketDetails.destination
              ? nextProps.ticketDetails.destination.name
              : ""
            : "",
          counterpart: nextProps.ticketDetails
            ? nextProps.ticketDetails.counterpart
              ? nextProps.ticketDetails.counterpart.name
              : ""
            : "",
          truckline: nextProps.ticketDetails
            ? nextProps.ticketDetails.truckline
              ? nextProps.ticketDetails.truckline.name
              : ""
            : "",
          dateOfTicket: nextProps.ticketDetails
            ? nextProps.ticketDetails.dateOfTicket
            : new Date().toISOString()
        }
      });

    if (Object.keys(nextProps.ticketDetails || []).length === 0) {
      this.setState({
        ticketDetails: {
          commodity: "",
          commodityVariety: "",
          estimatedHomeScaleShrinkBushels: "",
          fieldEstimatedLoadBushels: "",
          fieldEstimatedLoadWeight: "",
          fieldsEstimatedMoisture: "",
          homeScaleEstimatedMoisture: "",
          homeScaleWeightEmpty: "",
          homeScaleWeightFilled: "",
          shrinkMultiplier: "",
          billOfLading: "",
          loadNumberIndValue: "",
          ticketNumber: "",
          destination: "",
          counterpart: "",
          truckline: "",
          dateOfTicket: new Date().toISOString()
        }
      });
    }
  }

  handleDateChange = date => {
    if (date) {
      this.setState(
        prevState => {
          return {
            ticketDetailsRecieved: {
              ...prevState.ticketDetailsRecieved,
              receivedDate: new Date(date).toISOString()
              //moment(date._d).format("MM/DD/YYYY")
            }
          };
        },
        () => {}
      );
    }
  };

  render() {
    const { ticketDetails } = this.state;

    return (
      <div>
        <h3 className="mainHeading" style={{ paddingBottom: "1rem" }}>
          Ticket Details
        </h3>
        <Grid container spacing={8} style={{ paddingRight: "4em" }}>
          {/* <Grid item xs={10}>
                    <div style={{"display":"flex" , "justifyContent" : "space-between"}}>
                        <div style ={{"alignSelf": "center"}}>Commodity</div>
                        <div>
                        <InputFiled 
                            type="text"
                            disabled
                            value={ticketDetails.commodity}
                        />
                        </div>
                    </div>
                </Grid> */}

          <Grid item xs={6} className="labelFor">
            <div>Load Date</div>
          </Grid>
          <Grid item xs={6}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                className="date-picker"
                autoOk
                disabled
                format="MMM dd, yyyy p"
                value={ticketDetails.dateOfTicket}
                onChange={this.handleDateChange}
              />
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Commodity</div>
          </Grid>

          <Grid item xs={6}>
            <InputFiled
              type="text"
              disabled
              value={ticketDetails.commodity}
              handleChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Commodity Variety</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              disabled
              value={ticketDetails.commodityVariety}
              handleChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Est. Load weight (lbs)</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              disabled
              value={ticketDetails.fieldEstimatedLoadWeight}
              handleChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Field Estimated Load Bushels</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              disabled
              value={ticketDetails.fieldEstimatedLoadBushels}
              handleChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Est. Moisture %</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              disabled
              value={ticketDetails.fieldsEstimatedMoisture}
              handleChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Homescale wt. filled</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              disabled
              value={ticketDetails.homeScaleWeightFilled}
              handleChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Homescale wt. empty</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              disabled
              value={ticketDetails.homeScaleWeightEmpty}
              handleChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Home scale est. moisture</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              disabled
              value={ticketDetails.homeScaleEstimatedMoisture}
              handleChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Field Shrink Multiplier</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              disabled
              value={ticketDetails.shrinkMultiplier}
              handleChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Est. Home Scale Shrunk Bushels</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              disabled
              value={ticketDetails.estimatedHomeScaleShrinkBushels}
              handleChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Load Number</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              disabled
              value={ticketDetails.loadNumberIndValue}
              handleChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Ticket Number</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              disabled
              value={ticketDetails.ticketNumber}
              handleChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Destination</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              disabled
              value={ticketDetails.destination}
              handleChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Counterparty</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              disabled
              value={ticketDetails.counterpart}
              handleChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Bill of Lading</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              disabled
              value={ticketDetails.billOfLading}
              handleChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Truckline</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              disabled
              value={ticketDetails.truckline}
              handleChange={this.handleChange}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default TicketDetails;



// WEBPACK FOOTER //
// ./src/components/private/Reconciliation/TicketDetails.js